export default "__VITE_ASSET__JkDhbKbx__"